import type { RecommendationRow, RunDiffReasonBundle, RunDiffRow } from "./types";

export function formatDateTime(ts: string | null): string {
  if (!ts) return "-";
  try {
    return new Date(ts).toLocaleString();
  } catch {
    return ts;
  }
}

export function formatMoney(value: string | number | null | undefined): string {
  if (value === null || value === undefined) return "-";
  return `$${Number(value).toFixed(2)}`;
}

export function formatPct(value: number | string | null | undefined): string {
  if (value === null || value === undefined) return "-";
  return `${(Number(value) * 100).toFixed(1)}%`;
}

export function formatDate(value: string | null | undefined): string {
  if (!value) return "-";
  return value;
}

export function sumTruthStageUnits(values: Record<string, number> | null | undefined): number {
  if (!values) return 0;
  return Object.values(values).reduce((total, value) => total + Number(value || 0), 0);
}

export function formatCapitalReason(value: string | null | undefined): string {
  if (!value) return "-";
  return value.split("_").join(" ");
}

export function formatCapitalSignalCoverage(coverage: Record<string, number> | null | undefined): string {
  if (!coverage) return "-";
  const explicit = Number(coverage.explicit || 0);
  const mixed = Number(coverage.mixed || 0);
  const derived = Number(coverage.derived || 0);
  return `E ${explicit} | M ${mixed} | D ${derived}`;
}

export function formatSignedInt(value: number | null | undefined): string {
  if (value === null || value === undefined) return "-";
  return `${value >= 0 ? "+" : ""}${value}`;
}

export function formatSignedDays(value: number | null | undefined): string {
  if (value === null || value === undefined) return "-";
  return `${value >= 0 ? "+" : ""}${value}d`;
}

export function recommendationRiskBucket(row: RecommendationRow | null | undefined): string {
  if (!row) return "low";
  if (row.blocked) return "blocked";
  const days = row.days_of_cover !== null && row.days_of_cover !== undefined ? Number(row.days_of_cover) : 999;
  if (days <= 21) return "high";
  if (days <= 45) return "medium";
  return "low";
}

export function diffRowRiskBucket(row: RunDiffRow): string {
  return recommendationRiskBucket(row.current || row.previous || null);
}

export function summarizeDiffReasons(reasons: RunDiffReasonBundle[], limit = 3): string {
  return reasons
    .slice(0, limit)
    .map((reason) => reason.summary)
    .join(" | ");
}
